import Axios from "axios";
import { Order } from "@/models/Order";

const DUPLICATE_CHECK_CACHE_MS = 60_000;
let duplicateOpenOrderCheckEnabledCache: boolean | null = null;
let duplicateOpenOrderCheckCachedAt = 0;

export default class OrderService {
    static async getOpenOrders(patientId: number, storeId?: number): Promise<Order[]> {
        const query = storeId != null ? `?storeId=${storeId}` : "";
        const resp = await Axios.get<Order[]>(`/api/Order/open/${patientId}${query}`);
        return resp.data.map(o => new Order(o));
    }

    static async mergeOrders(sourceOrderId: number, targetOrderId: number): Promise<Order> {
        const resp = await Axios.post<Order>(`/order/merge-orders/${sourceOrderId}/${targetOrderId}`);
        return new Order(resp.data);
    }

    static async isDuplicateOpenOrderCheckEnabled(): Promise<boolean> {
        // Bounded so an admin enabling the toggle reaches already-open tabs without a reload.
        const age = Date.now() - duplicateOpenOrderCheckCachedAt;
        if (duplicateOpenOrderCheckEnabledCache != null && age >= 0 && age < DUPLICATE_CHECK_CACHE_MS) {
            return duplicateOpenOrderCheckEnabledCache;
        }

        try {
            const resp = await Axios.post<Record<string, boolean>>("/api/Configuration/values",
                ["enableDuplicateOpenOrderCheck"]);
            duplicateOpenOrderCheckEnabledCache = !!resp.data.enableDuplicateOpenOrderCheck;
            duplicateOpenOrderCheckCachedAt = Date.now();
            return duplicateOpenOrderCheckEnabledCache;
        } catch {
            // Don't cache a transient failure, or it disables the guard for the rest of the session.
            return false;
        }
    }
}
